import { Controller } from "@hotwired/stimulus";

// The "I can't find my property" box on the waiting list join form (ID-194).
// Ticking it empties the property picker inside the same block, so a
// property picked by mistake does not win over the typed address and APN.
export default class extends Controller {
  change(event) {
    if (!event.target.checked) return;

    const select = this.element.querySelector("select[data-property-select-target='select']");
    if (select && select.tomselect) select.tomselect.clear();
  }
}
